import { useId } from 'react';

export const useAriaId = (prefix: string): string => {
  const id = useId();

  return `${prefix}-${id}`;
};
